module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAICAMAAACSyWz7AAAAhFBMVEUAAAAAAP8gv/8cxv8cyP8bw/8hxP8gxv8fx/8dxP8dxf8cxv8gx/8gxf8gxv8fxv8fx/8fyP8eyP8hxf8hxv8gx/8gx/8fxv8gx/8gx/8hyP8hyP8hx/8gx/8gx/8gyP8gyP8gx/8hx/8hx/8hyP8hx/8hyP8hx/8gyP8gyP8gx/8hyP8OmDmHAAAAK3RSTlMAAQgJJSYnKCk0NTY3T1BRUlNcXV5fYGKoqaqrrK2ur8fIycrL4eLz9PX2zV7ibgAAAJ1JREFUGNOFkdkWgjAMRGtVcEFxRcAFBauQ/P//2VoCxfQc5623kzbJCFBZLHqNNvkLQKVrl201a1S6clmcKRCoVQbEwgpb3afEZk/OwtKcv8VYHy1LGuz03lt28rCkxr4Y8bKQcnnFgfK5HEfFkJ1dn2Al5jq6/X9Gf+c0YQc4eJrdcUY+Gt/oEXjWNOlYxX3t4nVoLCD4CcgGSb4Pd3AsjIDRDqEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/underline.png
// module id = 401
// module chunks = 0